export default __webpack_public_path__ + "static/media/Apply.3527d61c.png";